module.exports = __webpack_public_path__ + "static/media/mail_verification.4af67f05.png";